import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';

const horizontalLineWidth = '1px';

export interface CodeWrapperProps {
  size: 'half' | 'full';
}

export const CodeWrapper = styled.div<CodeWrapperProps>`
  margin-bottom: ${globalTheme.spacing.sm};

  & > * {
    overflow: auto;
  };

  ${(props) => props.size === 'half' && css`
    & > * {
      height: calc(12 * ${globalTheme.spacing.lg} - ${horizontalLineWidth});
    };
  `}

  ${(props) => props.size === 'full' && css`
    & > * {
      /* Compensate single instead of two horizontal lines with adding 'horizontalLineWidth'  */
      height: calc(29 * ${globalTheme.spacing.lg} + ${globalTheme.spacing.sm} + ${horizontalLineWidth});
    };
  `}
`;
